import { useEffect, useRef } from 'react';
import env from '@jwp/ott-common/src/env';

import useEventCallback from './useEventCallback';

type Props = {
  slide: () => void;
  enabled: boolean;
};

const slideInterval = env.APP_HERO_SHELF_AUTO_SLIDE_INTERVAL;

const useAutoSlide = ({ slide, enabled }: Props) => {
  const slideCallback = useEventCallback(slide);
  const intervalRef = useRef<NodeJS.Timeout>(null);
  const isEnabled = enabled && slideInterval !== undefined;

  const start = useEventCallback(() => {
    intervalRef.current = setInterval(() => {
      slideCallback();
    }, Number(slideInterval));
  });

  const stop = useEventCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = null;
  });

  const reset = useEventCallback(() => {
    if (!isEnabled) return;
    stop();
    start();
  });

  const resume = useEventCallback(() => {
    if (intervalRef.current || !isEnabled) return;
    start();
  });

  useEffect(() => {
    if (!isEnabled) return;

    start();

    return stop;
  }, [isEnabled, start, stop]);

  return { resume, pause: stop, reset };
};

export default useAutoSlide;
